import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { NextPage } from 'next';
import type { AppProps } from 'next/app';
import { appWithTranslation } from 'next-i18next';
import { ReactElement, ReactNode, useState } from 'react';
import { SWRConfig } from 'swr';
import { WagmiProvider } from 'wagmi';

import { Provider } from '@/components/ui/provider';
import { swrConfigValue } from '@/config/swr';
import { wagmiConfig } from '@/config/wagmi';

export type NextPageWithLayout<P = object, IP = P> = NextPage<P, IP> & {
  getLayout?: (page: ReactElement) => ReactNode;
};

type AppPropsWithLayout = AppProps & {
  Component: NextPageWithLayout;
};

const App = ({ Component, pageProps }: AppPropsWithLayout) => {
  const [queryClient] = useState(() => new QueryClient());
  const getLayout = Component.getLayout ?? ((page) => page);

  return (
    <WagmiProvider config={wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        <SWRConfig value={swrConfigValue}>
          <Provider>
            {getLayout(<Component {...pageProps} />)}
          </Provider>
        </SWRConfig>
      </QueryClientProvider>
    </WagmiProvider>
  );
};

export default appWithTranslation(App);
